import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {ParametrizacionLocalidadesTurnosService} from "../../services/parametrizacion-localidades-turnos.service";
import {ParametrizacionFeriadosService} from "../../services/parametrizacion-feriado.service";
import * as _ from 'lodash';

@Component({
  selector: 'app-parametrizacion-localidades-turnos',
  templateUrl: './parametrizacion-localidades-turnos.component.html',
  styleUrls: ['./parametrizacion-localidades-turnos.component.css']
})
export class ParametrizacionLocalidadesTurnosComponent implements OnInit {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbLocalizaciones: any[];
  cmbTurnos: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionLocalidadTurno: ParametrizacionLocalidadesTurnosService,
    private _parametrizacionFeriadosService: ParametrizacionFeriadosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionLocalidadTurno;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      localidadCode: ['', [Validators.required]],
      turno: ['', [Validators.required,]],
      horario: [''],
      localidad: [''],
      horaInicio: ['', [Validators.required,]],
      horaSalida: ['', [Validators.required,]]
    });
    this.cmbTurnos = [
      {
        id: 1,
        descripcion: "TURNO 1"
      },
      {
        id: 2,
        descripcion: "TURNO 2"
      },
      {
        id: 3,
        descripcion: "TURNO 3"
      },
      {
        id: 4,
        descripcion: "TURNO 4"
      },
    ];
    this.girdComponent();
    this.getAllLocalidadesTurnos();
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.formulario.reset();
    this.getFormInfo();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllLocalidadesTurnos() {
    this.loading = true;
    this._parametrizacionLocalidadTurno.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  getFormInfo(rowData?) {
    this.loading = true;
    this._parametrizacionFeriadosService.getAllLocalizaciones().subscribe((res: any) => {
      this.cmbLocalizaciones = res;
      if (this.editableForm) {
        const payload = this.formatData(rowData);
        this.formulario.setValue(payload);
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbLocalizaciones = [];
    });
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'LOCALIDAD',
        field: 'localidad.localidad',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'TURNO',
        field: 'turno',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'HORARIO',
        field: 'horario',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarLocalidadTurno.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarLocalidadTurno({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.getFormInfo(rowData);
  }

  formatData(data) {
    let rowData = _.cloneDeep(data);
    if (rowData.turno) {
      const tipo = this.cmbTurnos.find(turno => turno.descripcion.trim().toLowerCase() === rowData.turno.trim().toLowerCase());
      rowData.turno = tipo.descripcion;
    }
    if (rowData.localidadCode) {
      const localidad = this.cmbLocalizaciones.find(localidad => localidad.localidad.trim().toLowerCase() === rowData.localidad.localidad.trim().toLowerCase());
      rowData.localidadCode = localidad.codigo;
    }
    return rowData;
  }

  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._parametrizacionLocalidadTurno.borrarLocalidadTurno(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarLocalidadTurno();
      } else {
        this.guardarLocalidadTurno();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarLocalidadTurno() {
    let payload = _.cloneDeep(this.formulario.value);
    payload.horario = payload.horaInicio + ' - ' + payload.horaSalida;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionLocalidadTurno.actualizarLocalidadTurno(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllLocalidadesTurnos();
      this.regresar();
    });
  }

  guardarLocalidadTurno() {
    let payload = _.cloneDeep(this.formulario.value);
    payload.horario = payload.horaInicio + ' - ' + payload.horaSalida;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._parametrizacionLocalidadTurno.guardarLocalidadTurno(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllLocalidadesTurnos();
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

}
